<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2021-06-23 05:04:38
    Description : 小组
  -->
  <div class="page">
    <div class="select select-group">
      <el-button
        size="small"
        type="primary"
        @click="goGroupSetting"
        style="margin-top: -2px"
      >
        <img
          src="@/assets/icon/setting.png"
          style="width: 12px; vertical-align: bottom"
        />
        小组设置
      </el-button>
      <el-select
        v-model="type"
        size="small"
        style="
          width: 180px;
          vertical-align: top;
          margin-left: 8px;
          margin-top: -2px;
        "
        @change="getList()"
      >
        <el-option label="我创建的小组" value="created" />
        <el-option label="我的管理的小组" value="manage" />
        <el-option label="我加入的小组" value="joined" />
      </el-select>
    </div>
    <div
      v-for="(item, i) in dataList"
      :key="item.id"
      class="item"
      @click="open(`/group/groupDetail/list?groupId=${item.id}`)"
    >
      <div>
        <el-image class="cover" :src="baseUrl + item.background">
          <div slot="error" class="image-slot">
            <img
              class="cover"
              src="https://pub-glb-st.cn-e1.acs-cdn.gaiamount.com/static/img/B3.jpg"
            />
          </div>
        </el-image>
      </div>
      <div class="info">
        <div class="title">{{ item.name }}</div>
        <div class="detail">{{ item.description }}</div>
      </div>
      <div class="info2">
        <span style="font-weight: bold; font-size: 14px"
          >{{ item.groupStatistics.memberCount }}
        </span>
        <span style="color: #b2b2b3">成员</span>
        <span> | </span>
        <span style="font-weight: bold; font-size: 14px">
          {{ item.groupStatistics.worksCount }}
        </span>
        <span style="color: #b2b2b3">创作</span>
        <span style="float: right">
          <span style="font-weight: bold; font-size: 14px">{{
            item.user.nickname
          }}</span>
          <span style="margin: 0 5px; color: #b2b2b2"> | </span>
          <span style="font-weight: 400; color: #b2b2b2">
            {{ $dayjs(item.createTime).format("YYYY.MM.DD hh:mm:ss") }}
          </span>
        </span>
      </div>
    </div>

    <div class="loading-btn" v-if="showLoading">
      <i class="el-icon-loading" v-show="loading"></i>
      <span @click="loadMore">
        {{ loading ? "加载中" : "点击加载更多" }}
      </span>
    </div>
  </div>
</template>

<script>
import { getJoinedList, getCreatedList, getManageList } from "@/api/group";
export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      type: "created",
      showLoading: true,
      loading: false,
      page: {
        pageIndex: 1,
        pageSize: 8,
        total: 1,
      },
      dataList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    open(url) {
      open(url);
    },
    getList(pageIndex = 1) {
      if (this.type === "created") {
        this.getCreatedList(pageIndex);
      } else if (this.type === "manage") {
        this.getManageList(pageIndex);
      } else if (this.type === "joined") {
        this.getJoinedList(pageIndex);
      }
    },
    loadMore() {
      this.getList(this.page.pageIndex + 1);
    },
    /**
     * 处理分页
     */
    flushPage(res) {
      this.page.pageIndex = res.page.pageIndex;
      this.page.pageSize = res.page.pageSize;
      this.page.total = res.page.total;
      if (res.page.pageIndex * res.page.pageSize >= res.page.total) {
        this.showLoading = false;
      }
      setTimeout(() => {
        this.$forceUpdate();
      }, 0);
    },
    getJoinedList(pageIndex = 1) {
      this.page.pageIndex = pageIndex;
      this.loading = true;
      getJoinedList({ ...this.page, sort: "time" })
        .then((res) => {
          if (pageIndex === 1) {
            this.dataList = res.myJoinGroupList;
          } else {
            this.dataList = [...this.dataList, ...res.myJoinGroupList];
          }
          this.flushPage(res);
          this.loading = false;
        })
        .catch((res) => {
          console.log(res);
          this.loading = false;
        });
    },
    getCreatedList(pageIndex = 1) {
      this.page.pageIndex = pageIndex;
      this.loading = true;
      getCreatedList({ ...this.page, sort: "time" })
        .then((res) => {
          if (pageIndex === 1) {
            this.dataList = res.groups;
          } else {
            this.dataList = [...this.dataList, ...res.groups];
          }
          this.flushPage(res);
          this.loading = false;
        })
        .catch((res) => {
          console.log(res);
          this.loading = false;
        });
    },
    getManageList(pageIndex = 1) {
      this.page.pageIndex = pageIndex;
      this.loading = true;
      getManageList({ ...this.page, sort: "time" })
        .then((res) => {
          if (pageIndex === 1) {
            this.dataList = res.groupManagers.map((el) => {
              return el.group;
            });
          } else {
            this.dataList = [
              ...this.dataList,
              ...res.groupManagers.map((el) => {
                return el.group;
              }),
            ];
          }
          this.flushPage(res);
          this.loading = false;
        })
        .catch((res) => {
          console.log(res);
          this.loading = false;
        });
    },
    goGroupSetting() {
        const id = JSON.parse(localStorage.getItem('user')).account.id
        this.open(`/personal/index/${id}#groupSetting`)
    }
  },
};
</script>

<style lang="less" scoped>
.select-group {
  text-align: right;
  height: 50px;
}
.page {
  margin: -40px auto 0;
}
.loading-btn {
  margin: 20px 0 40px;
  text-align: center;
  cursor: pointer;
}
.item {
  width: 100%;
  height: 374px;
  margin-bottom: 30px;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  .cover {
    width: 100%;
    height: 300px;
  }
  .info {
    position: relative;
    height: 0;
    top: -124px;
    left: 40px;
    .title {
      margin-bottom: 20px;
      font-size: 26px;
      font-weight: bold;
      color: #ffffff;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    .detail {
      width: 780px;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      overflow: hidden;
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
  .info2 {
    padding: 30px;
    font-size: 12px;
  }
}
</style>
